import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { PersistenceService } from '../../../services/persistence.service';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { EnvironmentService } from '../../../services/environment.service';
import { PgProfileEditorService } from '../../pg-profile-editor.service';

@Component({
    selector: 'app-pg-login-handler-default',
    standalone: false,
    templateUrl: './pg-login-handler-default.component.html',
    styleUrl: './pg-login-handler-default.component.scss',
})
export class PgLoginHandlerDefaultComponent implements OnInit {
    constructor(private authService:AuthService, private persistenceService:PersistenceService, private environmentService:EnvironmentService, private pgProfileEditorService:PgProfileEditorService) {}
    
    @Output() setUserRequest = new EventEmitter<string>()

    isLoading = false;
    loginError = false;

    hasSSOLogin = {
        google: false,
        cohesion: false
    };

    ngOnInit(): void {
        let _savedObj = PGUtilities.tryParseJSON(this.persistenceService.getItem('PGLoginStatus')) 
        if(_savedObj) {
            this.loginUsername = _savedObj.user;
        }

        // Travel tourist API has no Entourance SSO endpoints
        if(this.environmentService.environment.TravelAPIUrl) {
            this.isLoading = false;
            return;
        }

        this.isLoading = true;

        let _reqNum = 0;

        for(let i in this.hasSSOLogin) {
            _reqNum++;

            let _http = new XMLHttpRequest();
            _http.open('HEAD', this.environmentService.environment.EntouranceAPIUrl + '/login/' + i + '/');
            _http.onreadystatechange = () => {
                if (_http.readyState === _http.DONE) {
                    if(_http.status != 401) {
                        this.hasSSOLogin[i] = true;
                    }
    
                    _reqNum--;
                    if(_reqNum == 0) this.isLoading = false;
                }
            };
            _http.send();
        }
    }

    onLoginDefaultKeyUp(event:KeyboardEvent) {
        if(event.key == 'Enter') {
            this.doLoginDefault();
        }
    }

    loginUsername:string = null;
    loginPassword:string = null;

    canLoginDefault() {
        return this.loginUsername != null && this.loginUsername != '' && this.loginPassword != null && this.loginPassword != ''
    }

    doLoginDefault() {
        if(this.canLoginDefault()) {
            this.isLoading = true;
            this.loginError = false;
    
            this.authService.login(this.loginUsername, this.loginPassword).then(() => {
                this.isLoading = false;
                this.persistenceService.setItem('PGLoginStatus', JSON.stringify({
                    mode: 'default',
                    user: this.loginUsername
                }), 'technical');
            }, () => {
                this.loginError = true;
                this.isLoading = false;
            })
        }
    }

    doSSOLogin(login:string) {
        window.location.href = this.environmentService.environment.EntouranceAPIUrl + '/login/' + login + '/?returnUrl=' + encodeURIComponent(window.location.href)
    }

    userRequest:'password-recover'|'create-account' = null;

    startPasswordRecover() {
        this.userRequest = 'password-recover';
        this.setUserRequest.emit(this.userRequest)
    }

    startCreateAccount() {
        this.userRequest = 'create-account';
        this.setUserRequest.emit(this.userRequest)
    }

    cancelUserRequest() {
        this.userRequest = null;
        this.setUserRequest.emit(this.userRequest)
    }

    doUserRequest() {
        this.pgProfileEditorService.requestChangePassword();
    }
}
